import React from 'react';

import { AnimatePresence } from 'framer-motion';

import faceScreamingImg from '@pkg/assets/images/face-screaming.png';
import { Button } from '@pkg/components/Sections/Profile/Buttons';
import { Colors } from '@pkg/components/Sections/Profile/Buttons/ButtonBase';
import { Modal } from '@pkg/components/modals';

import { CompactPadding, CTAWrapper, FaceScreamingImage, Heading, SubHeading } from './styles';
interface ConfirmModalProps {
    onClose: VoidFunction;
    isOpen: boolean;
    headingCopy: string;
    subheadingCopy?: React.ReactElement | string;
    onConfirm?: VoidFunction;
    onCancel?: VoidFunction;
    confirmCTACopy?: string;
    cancelCTACopy?: string;
    isLoading?: boolean;
    compact?: boolean;
}

export const ConfirmModal = ({
    headingCopy,
    subheadingCopy,
    onConfirm,
    cancelCTACopy = 'Discard',
    confirmCTACopy = 'Confirm',
    isLoading = false,
    onCancel,
    onClose,
    isOpen,
    compact = false,
}: ConfirmModalProps) => {
    const ctaSize = compact ? 'small' : 'medium';
    const contentMarkup = (
        <Modal.Layout>
            <Modal.Layout.Section>
                <FaceScreamingImage $compact={compact} src={faceScreamingImg} alt="Face screaming emoji" />
                <Heading $compact={compact}>{headingCopy}</Heading>
                {subheadingCopy && <SubHeading $compact={compact}>{subheadingCopy}</SubHeading>}
            </Modal.Layout.Section>
            <Modal.Layout.Section alignEnd={!compact}>
                <CTAWrapper $compact={compact}>
                    {onConfirm && (
                        <Button size={ctaSize} onClick={onConfirm}>
                            {confirmCTACopy}
                        </Button>
                    )}
                    {onCancel && (
                        <Button color={Colors.clear} disabled={isLoading} size={ctaSize} onClick={onCancel}>
                            {cancelCTACopy}
                        </Button>
                    )}
                </CTAWrapper>
            </Modal.Layout.Section>
        </Modal.Layout>
    );

    return (
        <AnimatePresence mode="wait">
            {isOpen && (
                <Modal fullScreenMobile={false} padded={!compact} onClose={onClose}>
                    <CompactPadding $compact={compact}>{contentMarkup}</CompactPadding>
                </Modal>
            )}
        </AnimatePresence>
    );
};
